<template>
  <div class="checkout-upsell-item flex flex-col h-full">
    <div class="flex mb-16 h-full">
      <nuxt-link
        class="bg-main-product w-70 sm:w-80 flex cursor-pointer select-none"
        :to="itemRoute"
        @click="sendGtmImpression"
      >
        <div
          class="
            w-80
            h-96
            flex
            justify-center
            items-center
            rounded-regular
            overflow-hidden
          "
        >
          <img
            :src="item.standardImage"
            class="w-full h-full object-cover"
            :alt="$lang('product_page', 'product_image_alt')"
            height="94"
            width="80"
          >
        </div>
      </nuxt-link>
      <div class="flex flex-col pl-16 h-full">
        <div class="flex justify-between items-center mb-4 md:max-w-none max-w-208">
          <nuxt-link
            class="text-small cursor-pointer select-none mr-8"
            :to="itemRoute"
            @click="sendGtmImpression"
          >
            {{ item.title }}
          </nuxt-link>
        </div>
        <div class="flex justify-between items-center mb-16">
          <div v-if="item.showAsOnSale" class="flex flex-col items-end">
            <div class="text-price text-warning float-right">
              {{ item.price }}
            </div>
            <div class="text-size-chart text-black-50 line-through float-right">
              {{ item.priceBeforeDiscount }}
            </div>
          </div>
          <div v-else class="text-price float-right">
            {{ item.price }}
          </div>
        </div>
        <div class="flex mt-auto">
          <div
            v-for="item in item.items"
            :key="item.item"
            class="mr-8 last:mr-0 md:flex-initial w-full md:flex-1 mb-8"
          >
            <TabSelector
              :text="item.name"
              :disabled="item.stock === 'no'"
              :selected="selectedItem && selectedItem.item === item.item"
              narrow
              :fullwidth="uiStore.isMobile"
              @click="selectedItem = item"
            />
          </div>
        </div>
      </div>
    </div>
    <ButtonComponent
      is-block
      :disabled="!selectedItem"
      :loading="loading"
      :text="$lang('checkout', 'select_product')"
      @click="addToCart"
    />
  </div>
</template>

<script setup lang="ts">
import type Product from '~/models/product';
import { useConfigStore } from '~/store/config';
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
import TabSelector from '~/components/generic/TabSelector.vue';
import { useCartStore } from '~/store/cart';
import { useUiStore } from '~/store/ui';
import { pushProductClick } from '~/composables/useTracking';
const config = useConfigStore();
const cartStore = useCartStore();

const uiStore = useUiStore();

const props = defineProps<{
  item: Product,
}>();

const emit = defineEmits<{
  (e: 'suspendKco'): void;
  (e: 'resumeKco'): void;
}>();

const loading = ref(false);
const selectedItem = ref<EcomProductItem | null>(props.item.items[0]);

const itemRoute = computed(()=> {
  return config.getProductRoute(props.item.ecomId)?.route || '/';
});

const addToCart = async() => {
  if (props.item && props.item.available && selectedItem.value) {
    loading.value = true;
    emit('suspendKco');

    const res = cartStore.addToCart({
      product: props.item,
      itemId: selectedItem.value.item,
      quantity: 1,
    });

    if (!res) {
      uiStore.setError('Couldn\'t add to cart');
    }

    emit('resumeKco');
    loading.value = false;
  }
};

const sendGtmImpression = () => {
  pushProductClick(props.item, 'Checkout');
};
</script>

<style scoped lang="postcss">
</style>
